// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionJ_comp__xseyS"};